import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from './api.service';

@Injectable()
export class ShipownerService extends ApiService {
  constructor(private http: Http) {
    super('api/shipowners/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/shipowner.service.ts